<template>
  <div class="wrapper fadeInDown" >
    <Loading :active.sync="loading" :lock-scroll="true" :is-full-page="true" :opacity="0.7" color="#F58549"></Loading>
    <div v-if="!loading" id="formContent">
      <p style="margin-top: 20px;">Introdu noua ta parolă</p>
      <v-form>
        <v-text-field
          v-model="pass"
          style="margin: 5px 20px 5px 20px;"
          :append-icon="showPass1 ? 'mdi-eye' : 'mdi-eye-off'"
          :type="showPass1 ? 'text' : 'password'"
          label="Parola"
          @click:append="showPass1 = !showPass1"
          @keyup.enter="submit()">
        </v-text-field>

        <v-text-field
          v-model="passConfirm"
          style="margin: 5px 20px 5px 20px;"
          :rules="[emailMatch]"
          :append-icon="showPass2 ? 'mdi-eye' : 'mdi-eye-off'"
          :type="showPass2 ? 'text' : 'password'"
          label="Confirmă parola"
          @click:append="showPass2 = !showPass2"
          @keyup.enter="submit()">
        </v-text-field>
      </v-form>

      <div class="container">
        <button
          type="button"
          class="buton btn"
          style="margin-right: 2vh;"
          @click="submit()">
          Schimbă parola
        </button>

        <button
          type="button"
          class="buton btn"
          style="margin-right: 2vh;">
          <router-link style="text-decoration: none; color:black;" to="/login">
            Înapoi
          </router-link>
        </button>
      </div>
    </div>

    <sweet-modal ref="notifySuccess" icon="success" @close="goToLogin()">
      <div style="margin-bottom: 2vh;">Parola a fost resetată</div>

      <div>
        <button type="button" class="buton btn" style="border-color: #F58549; margin-right: 2vh;" @click="goToLogin()">OK</button>
      </div>
    </sweet-modal>
  </div>
</template>

<script>

import Loading from 'vue-loading-overlay'
import {SweetModal} from 'sweet-modal-vue'
import axios from 'axios'
export default {
  components: {
    Loading,
    SweetModal
  },

  data: () => ({
    pass: '',
    passConfirm: '',
    showPass1: false,
    showPass2: false,
    loading: false
  }),

  methods: {
    goToLogin(){
      this.$router.replace({ name: 'login' })
    },

    submit () {
      if(this.pass && this.pass === this.passConfirm) {

        this.loading = true

        axios.put('auth/reset_password', {
          code: this.$route.params.code,
          password: this.pass
        }).then(() => {
          this.loading = false
          this.$refs.notifySuccess.open()
        }).catch(e => {
          console.log(e)
          alert("Ceva nu a mers bine")
        })

        this.pass = ''
        this.passConfirm = ''

      } else {
        alert("Date completate incorect")
      }
    },
  },

  computed: {
    emailMatch() {
      if(this.pass !== this.passConfirm) {
        return "Parolele nu se potrivesc"
      }

      return true
    }
  }
}
</script>

<style>
.wrapper {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  min-height: 100%;
}

#formContent {
  -webkit-border-radius: 10px 10px 10px 10px;
  border-radius: 10px 10px 10px 10px;
  background: #fff;
  padding: 30px;
  width: 90%;
  max-width: 450px;
  position: relative;
  padding: 0px;
  -webkit-box-shadow: 0 10px 10px 0 rgba(0,0,0,0.3);
  box-shadow: 0 10px 10px 0 rgba(0,0,0,0.3);
  text-align: center;
}
</style>
